/**
 * Created by zhangrp on 2018-07-13.
 */
import { MsgBox, Vue } from '../../app.vues';
//
import SwbApplyDesc from './ApplyDesc';
Vue.regist(SwbApplyDesc);

// 简单的申请描述弹出框
export function openApplyDescDlg(title, params, callback) {
    title = title == null ? '申请描述' : title;
    let desc = params.desc || null;
    Vue.$showDialog({
        title: title,
        width: 500,
        height: 300,
        showCloseBtn: true,
        template: '<swb-apply-desc :desc="desc" ref="swb_apply_desc"/>',
        data: {
            desc: desc
        },
        okClicked: function () {
            let result = this.$refs.swb_apply_desc.getDlgResult() || {};
            if(result.type === 'info') {
                let data = result.data;
                callback(data);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {}
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/stock/selectDlg.js
// module id = 62
// module chunks = 1